import React from 'react';
import Icon from '../../../components/AppIcon';

const WellnessMetrics = () => {
  const metrics = [
    {
      label: 'Total Bookings',
      value: '347',
      change: '+12%',
      trend: 'up',
      icon: 'Calendar',
      color: 'primary'
    },
    {
      label: 'Guest Wellness Score',
      value: '4.8',
      change: '+0.2',
      trend: 'up',
      icon: 'Heart',
      color: 'success'
    },
    {
      label: 'EES Utilization',
      value: '82%',
      change: '+5%',
      trend: 'up',
      icon: 'Zap',
      color: 'accent'
    },
    {
      label: 'Revenue',
      value: '$24.5K',
      change: '+18%',
      trend: 'up',
      icon: 'DollarSign',
      color: 'warning'
    }
  ];

  const getColorClasses = (color, variant = 'bg') => {
    const colorMap = {
      primary: {
        bg: 'bg-primary-100',
        text: 'text-primary',
        icon: 'text-primary'
      },
      success: {
        bg: 'bg-success-100',
        text: 'text-success',
        icon: 'text-success'
      },
      accent: {
        bg: 'bg-accent-100',
        text: 'text-accent-600',
        icon: 'text-accent-600'
      },
      warning: {
        bg: 'bg-warning-100',
        text: 'text-warning-600',
        icon: 'text-warning-600'
      }
    };
    return colorMap[color]?.[variant] || '';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="bg-surface p-6 rounded-lg shadow-elevation-1 hover:shadow-elevation-2 transition-all duration-200"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`p-3 rounded-md ${getColorClasses(metric.color)}`}>
              <Icon 
                name={metric.icon} 
                size={20} 
                className={getColorClasses(metric.color, 'icon')}
              />
            </div>
            <div className="flex items-center space-x-1">
              <Icon 
                name={metric.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
                className={metric.trend === 'up' ? 'text-success' : 'text-error'}
              />
              <span 
                className={`text-sm font-medium ${
                  metric.trend === 'up' ? 'text-success' : 'text-error'
                }`}
              >
                {metric.change}
              </span>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-text-primary mb-1">
              {metric.value}
            </h3>
            <p className="text-text-secondary text-sm">
              {metric.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WellnessMetrics;